<template>

  <div id="vote_component">
    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>

    <div class="card h-100 p-4">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0 text-danger w-65">{{ referendum.title }}</h5>
        <div class="ml-auto d-block" v-if="referendum.has_voted">
          <a data-tooltip="tooltip" data-placement="top" title="Commenter"
             :href="get_referendum_link(referendum.id)"
             class="btn btn-primary btn-xs btn-icon rounded-circle">
            <i class="fas fa-comments"></i>
          </a>
          <p class="btn mb-0 px-0">
            {{ referendum.nb_comments }}
          </p>
        </div>
      </div>

      <hr class="my-3">
      <div class="mb-3"><p>{{ referendum.description }}</p></div>
      <div class="mt-auto">
        <div class="w-100" v-if="referendum.has_voted">
          <div class="row">
            <div class="col-4 px-0">
              <span class="font-weight-bold mr-1">OUI :</span>
            </div>
            <div class="col-8">
              <div class="progress">
                <div class="progress-bar bg-success" role="progressbar"
                     :style="'width: ' + percent_yes + '%'" :aria-valuenow="percent_yes" aria-valuemin="0"
                     aria-valuemax="100">{{percent_yes}}%
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 px-0">
              <span class="font-weight-bold mr-1">NON :</span>
            </div>
            <div class="col-8">
              <div class="progress">
                <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percent_no + '%'"
                     :aria-valuenow="percent_no" aria-valuemin="0" aria-valuemax="100">{{percent_no}}%
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 px-0">
              <span class="font-weight-bold mr-1">ABSTENTION :</span>
            </div>
            <div class="col-8">
              <div class="progress">
                <div class="progress-bar bg-info" role="progressbar" :style="'width: ' + percent_abstention + '%'"
                     :aria-valuenow="percent_abstention" aria-valuemin="0" aria-valuemax="100">{{percent_abstention}}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 mt-2" v-if="!referendum.has_voted">
          <button type="button" data-tooltip="tooltip" data-placement="top" title="Oui"
                  @click="send_vote(1)"
                  class="btn btn-soft-primary btn-xs btn-icon rounded-circle">
            <i class="fa fa-thumbs-up fa-fw"></i>
          </button>

          <button type="button" data-tooltip="tooltip" data-placement="top" title="Non"
                  @click="send_vote(2)"
                  class="btn btn-soft-danger btn-xs btn-icon rounded-circle">
            <i aria-hidden="true" class="fa fa-thumbs-down fa-fw"></i>
          </button>
          <button type="button" data-tooltip="tooltip" data-placement="top" title="Abstention"
                  @click="send_vote(3)"
                  class="btn btn-soft-dark btn-xs btn-icon rounded-circle">
            <i aria-hidden="true" class="fa fa-ban fa-fw"></i>
          </button>
        </div>
        <div class="w-100 mt-2 text-center" v-else>
          <span class="alert alert-success py-1 px-2"
                v-if="referendum.has_voted">Vous avez déjà voté : {{ referendum.vote }}</span>
        </div>
        <div v-if="!!is_admin && !homepage" class="card-footer border-0 pt-2 pb-0 ml-2 mr-2">
          <div class="row">
            <a @click='edit_referendum()'   class="btn btn-sm btn-soft-dark btn-pill transition-3d-hover col-6" href="javascript:"><i class="fas fa-cogs"></i></a>
            <a @click='delete_referendum()' class="btn btn-sm btn-soft-danger btn-pill transition-3d-hover col-6" href="javascript:"><i class="fas fa-trash"></i></a>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
export default {
  props: {
    homepage: Boolean,
    referendum: Object,
    is_admin: Boolean
  },

  data: function () {
    return {
      message: '',
      message_type: '',
      percent_yes: Number,
      percent_no: Number,
      percent_abstention: Number,
    }
  },

  mounted() {
    const referendum = this.referendum;
    this.percent_yes = Math.round(parseInt(referendum.total_yes) * 100 / parseInt(referendum.total_vote))
    this.percent_no = Math.round(parseInt(referendum.total_no) * 100 / parseInt(referendum.total_vote))
    this.percent_abstention = Math.round(parseInt(referendum.total_abstention) * 100 / parseInt(referendum.total_vote))
  },


  watch: {
    referendum: function (newVal, oldVal) { // watch it
      const referendum = this.referendum;

      this.percent_yes = Math.round(parseInt(referendum.total_yes) * 100 / parseInt(referendum.total_vote))
      this.percent_no = Math.round(parseInt(referendum.total_no) * 100 / parseInt(referendum.total_vote))
      this.percent_abstention = Math.round(parseInt(referendum.total_abstention) * 100 / parseInt(referendum.total_vote))
    },
  },

  methods: {
    edit_referendum: function () {
      this.$emit('edit_referendum', this.referendum)
    },
    delete_referendum: function () {
      this.$emit('delete_referendum', this.referendum.id)
    },

    close_message: function () {
      this.message = null;
    },

    get_referendum_link: function (id) {
      return "/module/dlnkvotes/referendum?id=" + id
    },

    send_vote: function (value) {
      const _this = this
      const url = '/modules/dlnkvotes/actions/vote.php'

      $('.tooltip').tooltip('hide')

      axios.get(url +
          '?referendum_id=' + _this.referendum.id +
          '&vote=' + value)
          .then(function (response) {
            _this.message = 'Votre votre a été pris en compte'
            _this.message_type = 'alert-success'
            _this.$emit('refresh')
          })
          .catch(function (error) {
            _this.message = 'Erreur, veuillez contacter votre communauté'
            _this.message_type = 'alert-danger';
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>
